import React from 'react'
import HomeProducts from '../components/HomeProducts'
import { Container } from 'react-bootstrap'
import Banner from '../components/Banner';
  const bannerImage = '/static/media/1400.5b998818e97ff18c5b37.jpg';import QuoteBox from '../components/Quote';

const Catalogues = () => {
  return (
    <>
      <h1 className="seo-h1">Download ACP Sheet Catalogues and Shade Cards</h1>
      <p className="seo-intro">
        Download official Alutuff ACP sheet shade cards, design catalogues, and technical brochures to explore modern finishes, textures, and specifications.
      </p>
      {/* Banner Section */}
      <div className='w-100'>
        <Banner
          image={bannerImage}
          heading="Catalogues"
          subheading="Welcome to our website"
        />
      </div>


<Container fluid >
<HomeProducts/>
</Container>

<div className='w-100'>
<QuoteBox/>
</div>
</>
  )
}

export default Catalogues
